import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const bannerAbout = () => {
  const banner = document.querySelector('.banner-about')
  const slides = document.querySelectorAll('.banner-about__slide')
  const arrow = document.querySelector('.banner-about__arrow')

  if (!banner || window.innerWidth <= 650) return

  const end = `+=${window.innerHeight * 0.75}`

  gsap
    .timeline({
      scrollTrigger: {
        trigger: banner,
        pin: true,
        start: 'top top',
        end: end,
        scrub: 1.1
      }
    })
    .to(slides[0], { clipPath: 'inset(0 0 100% 0)', ease: 'power3.out' })

  arrow.addEventListener('click', () => {
    lenis.scrollTo(1080, { duration: 3.4 })
  })
}

export default () => {}
